import React = require("react");
import styled from "styled-components";
import { Activity, fieldValidation, PublicAmorgUser } from "../../../amorg-common";
import { updateActivity } from "../../../api/activityClientApi";
import { rawColors } from "../../../designSystem/colors/color";
import { Flex } from '../../../designSystem/compositeComponents/FlexHelpers';
import { FormField } from "../../../designSystem/formField/FormField";
import { TextSaveField } from "../../../designSystem/formField/text/TextSaveField";
import { TextAreaSaveField } from "../../../designSystem/formField/textArea/TextAreaSaveField";
import { EditableText } from "../../../designSystem/compositeComponents/EditableText";
import { LoadingPageOverlay } from "../../../designSystem/LoadingPageOverlay";
import { DateStartEndTimeFields } from "../../../designSystem/formField/DateStartEndTimeFields";
import { MessageCard } from "../../../designSystem/Message";
import { PageSectionHeader } from "../../../designSystem/PageSectionHeader";
import { MeetingParticipantList } from "../participants/MeetingParticipantList";


type MeetingDetailsPanelProps = {
    componentTitle?: string,
    activity: Activity;
    periodSelection: 'date-time' | 'date',
    infoComponents?: React.ReactNode,
    extraComponents?: React.ReactNode,
    titleText?: string,
    descriptionText?: string,
    users: PublicAmorgUser[],
    participantTexts?: { header: string };
    onActivityUpdated: () => void;
};
export function MeetingDetailsPanel (props: MeetingDetailsPanelProps)
{
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState('');
    const [titleError, setTitleError] = React.useState<string>('');
    
    async function performUpdate (mutator: (activity: Activity) => void)
    {
        //const a = await getActivity(initialActivity.id);
        mutator(props.activity);
        const result = await updateActivity(
            props.activity.id,
            props.activity.title,
            props.activity.description,
            props.activity.start,
            props.activity.end,
            props.activity.location
        );
        if (result.errorMessage)
            setError('Der opstod en fejl ved opdatering af mødet. Prøv igen eller kontakt support');
        else
            setError('');
        
        props.onActivityUpdated();
        
        return result;
    }

    async function handleUpdateDates (start: Date, end: Date)
    {
        performUpdate((activity) =>
        {
            activity.start = start;
            activity.end = end;
        });
    }

    async function handleSaveTitle (value: string):Promise<boolean>
    {
        setLoading(true);
        const result = await updateActivity(props.activity.id, value, props.activity.description, props.activity.start, props.activity.end, props.activity.location);
        if(result.isSuccess)
        {
            setTitleError('');
            await props.onActivityUpdated();
            setLoading(false);
            return true;
        }
        else
        {
            setTitleError('Ugyldig titel');
            setLoading(false);
            return false;
        }
    }

    return (

        <Flex flexDirection="column" gap={32}>

            <LoadingPageOverlay loading={loading} />
            
            {props.activity &&
                <>
                {error && <MessageCard variant="error">{error}</MessageCard>}

                <Flex flexDirection="column" gap={8}>

                    <EditableText ariaLabel='Rediger mødetitel' placeholder='Mødetitel' 
                        value={props.activity.title}
                        errorMessage={titleError}
                        onSaveWithReturnValue={handleSaveTitle}
                        styleMode="H2"
                    />

                    <Flex flexDirection="column" gap={0}>
                        <PageSectionHeader styleVariant="dark">
                            Tid og sted
                        </PageSectionHeader>
                        <Flex>

                            <DateStartEndTimeFields
                                hideLabels
                                start={props.activity.start}
                                end={props.activity.end}
                                onChanged={handleUpdateDates} />
                        
                            <TextSaveField
                                formFieldLeadingIcon={"interface_glyph_location"}
                                // leadingIcon="interface_glyph_location"
                                trailingIcon={"interface_actions_edit"}
                                hideLabel
                                label={""}
                                formFieldStyle={{ flex: 1 }}
                                reserveLabelSpace={true}
                                value={props.activity.location}
                                
                                onSave={newValue =>
                                {
                                    if (fieldValidation.activity.location(newValue))
                                        performUpdate((a) => { a.location = newValue; });
                                }}
                                validator={(currentValue) =>
                                    fieldValidation.activity.location(currentValue)
                                        ? { valid: true }
                                        : { valid: false, errorMessage: 'Ugyldig beskrivelse. Maks. 200 tegn.' }
                                }
                            />

                        </Flex> 
                    </Flex>
                </Flex>

                <Flex flexDirection="column" gap={8}>
                    <PageSectionHeader styleVariant="dark">
                        Deltagere
                    </PageSectionHeader>
                    
                    {props.participantTexts &&
                        <FormField
                            label={""}
                            inputComponent={
                                <>
                                    <MeetingParticipantList
                                        activity={props.activity}
                                        users={props.users}
                                        onParticipantsUpdated={props.onActivityUpdated} />
                                </>
                            } />
                    }
                </Flex>
                <Flex flexDirection="column" gap={8}>
                    <PageSectionHeader styleVariant="dark">
                        Mødebeskrivelse
                    </PageSectionHeader>
                    <TextAreaSaveField
                        label={""}
                        minRows={3}
                        value={props.activity.description}
                        onSave={newValue =>
                        {
                            if (fieldValidation.activity.description(newValue))
                                performUpdate((a) => { a.description = newValue; });
                        }}
                        validator={(currentValue) =>
                            fieldValidation.activity.description(currentValue)
                                ? { valid: true }
                                : {
                                    valid: false, errorMessage: `Ugyldig beskrivelse. Maks. 10000 tegn (${currentValue.length}).`
                                }}
                    />
                </Flex>
                </>
            }
        </Flex>
    );
}

export const TestBox = styled.div`
    
    background: ${rawColors.gray.light};
    border-radius: 2px;
    padding: 2px 8px;
    height:42px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    
`